import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { Box, Button, Grid, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { AllocationLogDetails } from '../../types/inventoryAllocationLogs'

interface InventorySkeletonProps {
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      allocationLogDetails: AllocationLogDetails
    }>
  >
}
const InventorySkeleton: React.FC<InventorySkeletonProps> = ({ refetch }) => {
  return (
    <>
      <Grid
        container
        spacing={2}
        direction="column"
        alignItems="center"
        style={{ marginTop: 10 }}>
        {/* Title */}
        <Grid item>
          <Typography id="inventory-skeleton-title" variant="h6">
            {getTranslate('Allocation is not completed yet')}
          </Typography>
        </Grid>
        {/* Refresh Button */}
        <Grid item>
          <Box display="flex" alignItems="center">
            <Button
              variant="contained"
              color="primary"
              onClick={() => refetch()}
              startIcon={<RefreshIcon />}>
              {getTranslate('Refresh')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default InventorySkeleton
